import { format } from "date-fns";

import { CALCULATOR_STAGES } from "constants/calculator";

import { convertValueToLocale } from "helpers/convertValueToLocale";

export const getAcquisitionsCardColumns = () => [
  {
    key: "investObject",
    label: "Einheit",
    minWidth: 120,
    maxWidth: 120,
    justifyContent: "start",
  },
  {
    key: "type",
    label: "Bezeichnung",
    minWidth: 320,
    maxWidth: 320,
    justifyContent: "start",
  },
  {
    key: "percentage",
    label: "",
    minWidth: 20,
    maxWidth: 60,
    justifyContent: "end",
  },
  {
    key: "depreciation",
    label: "Abschreibung",
    minWidth: 120,
    maxWidth: 160,
    justifyContent: "end",
  },
  {
    key: "year",
    label: "Jahr",
    minWidth: 80,
    maxWidth: 80,
    justifyContent: "end",
  },
  {
    key: "quantity",
    label: "Betrag",
    minWidth: 80,
    maxWidth: 120,
    justifyContent: "end",
  },
];

export const getAcquisitionsCardData = ({
  calculation,
}: {
  calculation: any;
}) => {
  const propertyTaxFeeValue = calculation?.baseCalculation?.propertyTaxFee || 0;
  const purchaseNotaryAmount =
    calculation?.baseCalculation?.purchaseNotaryAmount || 0;
  const financingNotaryAmount =
    calculation?.baseCalculation?.financingNotaryAmount || 0;
  const propertyTax = calculation?.baseCalculation?.propertyTax || 0;
  const brokerFee = calculation?.baseCalculation?.brokerFee || 0;
  const brokerFeeValue = calculation?.baseCalculation?.brokerFeeValue || 0;
  const apartments = calculation?.baseCalculation?.apartmentsCalculation || [];
  const parkings = calculation?.baseCalculation?.parkingsCalculation || [];

  const purchaseDate = calculation?.baseCalculation?.stages?.find(
    (stage: any) => stage.type === CALCULATOR_STAGES.PURCHASE_STAGE
  )?.date;

  const purchaseYear = format(purchaseDate, "yyyy");

  const totalAcquisitionsQuantity =
    propertyTaxFeeValue +
    purchaseNotaryAmount +
    financingNotaryAmount +
    brokerFeeValue;

  const apartmentAcquisitionsData = apartments.flatMap(
    (apartment: any, index: number, apartments: any[]) => [
      {
        investObject: `Wohnung ${apartments.length > 1 ? index + 1 : ""}`,
        type: `Grunderwerbsteuer`,
        percentage: convertValueToLocale(propertyTax, 2, "%"),
        depreciation: "AfA",
        year: null,
        quantity: convertValueToLocale(
          apartment.propertyTaxFee,
          null,
          "€",
          null
        ),
      },
      ...(brokerFee > 0
        ? [
            {
              investObject: null,
              type: `Maklerprovision`,
              percentage: convertValueToLocale(brokerFee, 2, "%"),
              depreciation: null,
              year: null,
              quantity: convertValueToLocale(
                apartment.brokerFeeValue,
                null,
                "€",
                null
              ),
            },
          ]
        : []),
      {
        investObject: null,
        type: `Notar- und Grundbuchkosten Erwerb`,
        percentage: "1,30%",
        depreciation: "AfA",
        year: null,
        quantity: convertValueToLocale(
          apartment.aptFinancingNotaryAmount,
          null,
          "€",
          "0"
        ),
      },
      {
        investObject: null,
        type: `Notar- und Grundbuchkosten Finanzierung`,
        percentage: "0,70%",
        depreciation: "Werbungskosten",
        year: purchaseYear,
        quantity: convertValueToLocale(
          apartment.aptNotaryFeeValue,
          null,
          "€",
          null
        ),
      },
    ]
  );

  const parkingAcquisitionsData = parkings.flatMap(
    (parking: any, index: number, parkings: any[]) => [
      {
        investObject: `Stellplatz ${parkings.length > 1 ? index + 1 : ""}`,
        type: `Grunderwerbsteuer`,
        percentage: convertValueToLocale(propertyTax, 2, "%"),
        depreciation: "AfA",
        year: null,
        quantity: convertValueToLocale(parking.propertyTaxFee, null, "€", null),
      },
      ...(brokerFee > 0
        ? [
            {
              investObject: null,
              type: `Maklerprovision`,
              percentage: convertValueToLocale(brokerFee, 2, "%"),
              depreciation: null,
              year: null,
              quantity: convertValueToLocale(
                parking.brokerFeeValue,
                null,
                "€",
                null
              ),
            },
          ]
        : []),
      {
        investObject: null,
        type: `Notar- und Grundbuchkosten Erwerb`,
        percentage: "1,30%",
        depreciation: "AfA",
        year: null,
        quantity: convertValueToLocale(
          parking.parkingFinancingNotaryAmount,
          null,
          "€",
          null
        ),
      },
      {
        investObject: null,
        type: `Notar- und Grundbuchkosten Finanzierung`,
        percentage: "0,70%",
        depreciation: "Werbungskosten",
        year: purchaseYear,
        quantity: convertValueToLocale(
          parking.parkingNotaryFeeValue,
          null,
          "€",
          null
        ),
      },
    ]
  );

  const sumAcquisitionsData = {
    investObject: `Summe`,
    type: null,
    percentage: null,
    depreciation: null,
    year: null,
    quantity: convertValueToLocale(totalAcquisitionsQuantity, null, "€", null),
  };

  return [
    ...apartmentAcquisitionsData,
    ...parkingAcquisitionsData,
    sumAcquisitionsData,
  ];
};
